import * as React from 'react';

import { ITerm, IFacetResult } from '../../state-helpers/facets';
import { FacetTerm } from './facet-term';

interface IProps {
    facet: IFacetResult;
    onToggleTerm: (term: ITerm) => void;
}

interface IState {

}

export class FacetSection extends React.Component<IProps, IState> {

    render() {
        const { facet } = this.props;

        if (facet.terms.length == 0 || !facet.terms.some(t => t.hits > 0)) {
            return null;
        }

        const divId = 'search-facet-' + (facet.fieldName && facet.fieldName.replace(/\s+/g, '-')).toLowerCase();
        
        return (
            <div className="search-facet-item" id={divId}>
                <div className="search-facet-item-header">
                    <h5>{this.props.facet.name}</h5>
                </div>

                <div className="search-facet-item-list">
                    <fieldset>
                        {facet.terms.map(this.renderFacetTerm)}
                    </fieldset>
                </div>
            </div>
        );
    }

    renderFacetTerm = (term: ITerm, index: number) => {
        const { facet, onToggleTerm } = this.props;

        return (
            <FacetTerm
                key={term.id}
                term={term}
                onTermClick={() => onToggleTerm(term)} />
        )
    }
}